module.exports = "//public.getcloudapp.com/packs/media/images/icon-get-cloudapp-a96f81e9690fa8e46e8a27c13543540f.svg";